import { stripHtml } from './stripHtml';

export default function getItemName(item) {
  const anchorText = item.facets[0]?.anchor?.text;
  const itemTitle = stripHtml(item.title || '');
  const itemQuestion = stripHtml(item.question || '');
  const strippedAnchorText = stripHtml(anchorText || '');
  
  return {
    sequences: itemTitle,
    regions: 'Hotspot',
    question_and_answers: strippedAnchorText,
    instructional_contents: itemTitle,
    survey_question_and_answers: strippedAnchorText,
    free_responses: strippedAnchorText,
    ratings: itemQuestion,
    associations: strippedAnchorText,
    vocabulary: strippedAnchorText,
  }[item.templateType];
}